export default __webpack_public_path__ + "static/media/35-BeachTui.98954348.jpeg";